import React from 'react';
import {PuffLoader} from "react-spinners";
import Carousel from 'react-material-ui-carousel'
import '../CSS/Loading.css'

function Loading(props) {
    var height = props.height;
    var colors = props.color;
    var strings=[
        "Attending Classes","Organizing Fests","Preparing Practicals","Night Walks","Why Amity?",'First Bench Antartica?','Cooler 1500/-','Nescafe','DayScholars and Hostellers'
    ]

    var page = props.page;

    var index = (Math.floor(Math.random()*strings.length));
    return (
    <div style={{
        width:"100%",
        height:height,
        display:"flex",
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
        color:colors,
        fontSize:"20px",
        textAlign:'center'
    }}>
        <PuffLoader
            size={45}
            color={"rgb(10,78,149)"}/>

        {page==="Home"?"":
            <Carousel
            style={{
                color:colors
            }}
            className="Carousel"
            indicators='true'
            interval="2000"
            startAt={index}
            navButtonsAlwaysInvisible="true"
            indicatorContainerProps={{className:"Indicators"}}
            >
                {
                    strings.map((item, index)=>item)
                }  
            </Carousel>
        }
    </div>
  );
}


export default Loading;